export const unavailableContentLabel = 'Недоступный контент';
